import { render, staticRenderFns } from "./EditSellerTooltip.vue?vue&type=template&id=4dcd841d&scoped=true&"
import script from "./EditSellerTooltip.vue?vue&type=script&lang=js&"
export * from "./EditSellerTooltip.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerTooltip.vue?vue&type=style&index=0&id=4dcd841d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd841d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VDialog,VIcon,VLayout,VSpacer})
